import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Hand, Activity } from 'lucide-react';
import { Button } from '@/components/ui/button';
import PageHeader from '@/components/PageHeader';

export default function TestMotori({ patient }) {
  const navigate = useNavigate();

  return (
    <div className="page-container pb-24">
      <PageHeader
        title="Test Motori"
        subtitle="Scegli il test da eseguire"
        icon={Activity}
      />

      <div className="grid grid-cols-1 gap-6">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="bg-white rounded-3xl p-8 soft-shadow border border-slate-200/60"
        >
          <div className="flex items-start gap-6 mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center flex-shrink-0">
              <Hand className="w-9 h-9 text-white" />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-slate-900 mb-2">Finger Tapping Test</h2>
              <p className="text-base text-slate-600 leading-relaxed">
                Alterna rapidamente tra due pulsanti per 10 secondi. Misura la velocità e la costanza del movimento delle dita.
              </p>
            </div>
          </div>
          <Button
            data-testid="btn-tapping-test"
            onClick={() => navigate('/test-motori/tapping')}
            className="w-full min-h-[64px] text-lg font-semibold rounded-2xl bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-lg hover:shadow-xl transition-all duration-300 active:scale-[0.98]"
          >
            Inizia Tapping Test
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="bg-white rounded-3xl p-8 soft-shadow border border-slate-200/60"
        >
          <div className="flex items-start gap-6 mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center flex-shrink-0">
              <Activity className="w-9 h-9 text-white" />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-slate-900 mb-2">Test del Tremore</h2>
              <p className="text-base text-slate-600 leading-relaxed">
                Tieni il telefono fermo per 10 secondi. L'accelerometro misura l'intensità del tremore.
              </p>
            </div>
          </div>
          <Button
            data-testid="btn-tremor-test"
            onClick={() => navigate('/test-motori/tremor')}
            className="w-full min-h-[64px] text-lg font-semibold rounded-2xl bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white shadow-lg hover:shadow-xl transition-all duration-300 active:scale-[0.98]"
          >
            Inizia Test Tremore
          </Button>
        </motion.div>
      </div>
    </div>
  );
}
